import { useCheckParentPendingNPS } from '@actions';
import { useEffect, useState } from 'react';

type Params = {
  studentId: string;
  token: string | undefined;
};

const useParentNpsModal = ({ studentId, token }: Params) => {
  const { data: shouldShowNps } = useCheckParentPendingNPS(
    studentId,
    { token },
    {
      enabled: !!studentId && !!token,
    }
  );
  const [isNpsModalOpen, setIsNpsModalOpen] = useState(false);

  useEffect(() => {
    if (shouldShowNps) {
      setIsNpsModalOpen(true);
    }
  }, [shouldShowNps]);

  return { isNpsModalOpen };
};

export default useParentNpsModal;
